/*
  theme-editorial.js
  ---------------------------------------------------------------------------
  Small, dependency-free behaviours for the editorial redesign. Loaded
  after global.js and is purely additive:
  it never touches Dawn/Skeleton's own custom elements (sticky-header,
  header-drawer, slideshow-component, ...), it only toggles a class.
*/

(function () {
  'use strict';

  // -------------------------------------------------------------------
  // Always-transparent header (component-header-editorial.css): picks the
  // icon colour from what is under the middle of the header -- white over
  // a photo section or a dark background, black otherwise.
  // -------------------------------------------------------------------
  function initTransparentHeader() {
    var header = document.querySelector('.section-header');
    if (!header) return;

    var PHOTO_SECTIONS = '.hero-photo, .editorial-hero, .editorial-media__cell, .multirow .image-with-text__media';
    var IGNORED = '.shopify-section-group-header-group, newsletter-popup, #shopify-pc__banner';

    // Section backgrounds only: a button or card narrower than 60% of the
    // screen (e.g. a white button in a black section) never flips the ink.
    function isDark(element) {
      var minWidth = window.innerWidth * 0.6;
      for (var node = element; node && node.nodeType === 1; node = node.parentElement) {
        if (node.getBoundingClientRect().width < minWidth) continue;
        var rgba = window.getComputedStyle(node).backgroundColor.match(/[\d.]+/g);
        if (!rgba || (rgba.length === 4 && Number(rgba[3]) < 0.5)) continue;
        var luminance = (0.299 * rgba[0] + 0.587 * rgba[1] + 0.114 * rgba[2]) / 255;
        return luminance < 0.5;
      }
      return false;
    }

    function underHeaderIsDark() {
      var y = header.getBoundingClientRect().top + header.offsetHeight / 2;
      var elements = document.elementsFromPoint(window.innerWidth / 2, y);
      for (var i = 0; i < elements.length; i += 1) {
        if (elements[i].closest(IGNORED)) continue;
        if (elements[i].closest(PHOTO_SECTIONS)) return true;
        return isDark(elements[i]);
      }
      return false;
    }

    var queued = false;
    function update() {
      queued = false;
      header.classList.toggle('ac-header--light', underHeaderIsDark());
    }
    function queueUpdate() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(update);
    }

    update();
    window.addEventListener('scroll', queueUpdate, { passive: true });
    window.addEventListener('resize', queueUpdate);
    window.addEventListener('load', queueUpdate);
  }

  // -------------------------------------------------------------------
  // Editorial background videos (hero, media campaigns, backstage...):
  // pause playback under prefers-reduced-motion instead of relying only
  // on CSS to hide the element, and resume if the preference changes
  // mid-session. Shared by every section using the [data-editorial-video]
  // attribute (editorial-hero, editorial-media) — one listener set, not
  // one per section type.
  // -------------------------------------------------------------------
  function initEditorialVideos() {
    var videos = document.querySelectorAll('[data-editorial-video]');
    if (!videos.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function sync() {
      videos.forEach(function (video) {
        if (reduceMotion.matches) {
          video.pause();
        } else {
          video.play().catch(function () {});
        }
      });
    }

    sync();
    reduceMotion.addEventListener('change', sync);
  }

  document.addEventListener('DOMContentLoaded', initTransparentHeader);
  document.addEventListener('DOMContentLoaded', initEditorialVideos);
})();
